"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Column(_ref) {
  var _cn;

  var _data = _ref._data,
      _parent = _ref._parent,
      _index = _ref._index,
      align = _ref.align,
      alias = _ref.alias,
      empty = _ref.empty,
      transform = _ref.transform,
      _model = _ref._model,
      children = _ref.children;

  function getData() {
    var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var aliases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var alias = aliases[index];

    if (alias) {
      if (alias in model) {
        var result = model[alias];

        if (index >= aliases.length - 1) {
          return model[alias];
        }

        if (result !== null && result instanceof Object) {
          return getData(model[alias], aliases, ++index);
        }
      } else {
        return null;
      }
    }

    return model;
  }

  function _renderData() {
    try {
      var aliases = alias ? alias.split('.') : [];
      var model = (alias ? getData(_model, aliases) : _model) || empty;

      if (model && transform instanceof Function) {
        model = transform(model);
      }

      if (model || model === null) {
        if (children instanceof Function) {
          return children(model) || empty;
        } else {
          if (model !== null && model instanceof Object) {
            if (children) {
              return /*#__PURE__*/_react["default"].cloneElement(children, model);
            } else {
              return null;
            }
          } else {
            if (children) {
              return /*#__PURE__*/_react["default"].cloneElement(children, {
                value: model
              });
            } else {
              return model;
            }
          }
        }
      } else {
        return null;
      }
    } catch (e) {
      throw e;
    }
  }

  function getDataLocator() {
    var locator;

    if (_parent) {
      locator = _parent ? "".concat(_parent, ".col[").concat(_index, "]") : "col[".concat(_index, "]");
      locator = _data ? "".concat(locator, ".").concat(_data) : locator;
    } else {
      locator = _data ? "col[".concat(_index, "].").concat(_data) : '';
    }

    return locator;
  }

  var contentClassName = (0, _classnames["default"])(_defaultModule["default"]['content'], (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['content--left'], align === 'left'), (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['content--right'], align === 'right'), _cn));

  try {
    return /*#__PURE__*/_react["default"].createElement("td", {
      className: _defaultModule["default"]['col']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: contentClassName,
      "data-locator": getDataLocator()
    }, _renderData()));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement("td", {
      className: _defaultModule["default"]['col']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: contentClassName,
      "data-locator": getDataLocator()
    }, /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    })));
  }
}

Column.defaultProps = {
  _data: '',
  _parent: '',
  alias: null,
  title: null,
  empty: null,
  width: null,
  align: 'center',
  children: null,
  _model: null,
  transform: null
};
var _default = Column;
exports["default"] = _default;